<div style="width: 680px; height: 420px">
  <app-calendar
    [view]="view"
    [readonly]="readonly"
    [blockEvents]="blockEvents"
    [showWaitingTasks]="showWaitingTasks"
    [allowLegend]="allowLegend"
    [showHeaderBar]="showHeaderBar"
    [selectedDate]="selectedDate"
    [technicians]="technicians"
    (cellClick)="clickEvent.emit($event)"
  />
</div>
